import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-ec.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ViewApplicationDetailsEcConstants } from "./view-application-details-ec.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationDetailsEcComponent = class ViewApplicationDetailsEcComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    route;
    routerParamsService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsEcConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = ViewApplicationDetailsEcConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsEcConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsEcConstants.REFERENCE_NUMBER_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    referenceNumberLabel = ViewApplicationDetailsEcConstants.REFERENCE_NUMBER_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = ViewApplicationDetailsEcConstants.APPLICATION_TYPE_LABEL;
    descriptionLabel = ViewApplicationDetailsEcConstants.DESCRIPTION_LABEL;
    applicationTypes = [];
    applicantTypeFormControlName = ViewApplicationDetailsEcConstants.APPLICANT_TYPE_FORM_CONTROL_NAME;
    applicantTypeLabel = ViewApplicationDetailsEcConstants.WHO_IS_APPLYING_LABEL;
    applicantTypes = [];
    descriptionOfProposedWorkFormControlName = ViewApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_FORM_CONTROL_NAME;
    descriptionOfProposedWorkLabel = ViewApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_LABEL;
    descriptionOfProposedWorkNote = ViewApplicationDetailsEcConstants.DESCRIPTION_OF_PROPOSED_WORK_NOTE;
    phaseFormControlName = ViewApplicationDetailsEcConstants.PHASE_FORM_CONTROL_NAME;
    paymentTypeControlName = ViewApplicationDetailsEcConstants.PAYMENT_TYPE_CONTROL_NAME;
    estimatedCapacityControlName = ViewApplicationDetailsEcConstants.ESTIMATED_CAPACITY_FORM_CONTROL_NAME;
    phaseLabel = ViewApplicationDetailsEcConstants.PHASE_LABEL;
    conventionalPrepaidLabel = ViewApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LABEL;
    estimatedCapacityLabel = ViewApplicationDetailsEcConstants.ESTIMATED_CAPACITY_LABEL;
    saveBtnPlaceholder = ViewApplicationDetailsEcConstants.SAVE_BUTTON_PLACEHOLDER;
    phases = [];
    conventionalPrepaidOptions = [];
    application;
    getApplicationSaveObservableSubscription;
    constructor(aflaModuleStrategyService, viewApplicationService, route, routerParamsService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getLookups();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => {
                this.onGetApplicationCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsEcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onBtnSaveClicked() {
        if (this.detailsForm.valid) {
            const applicationDetailsData = this.buildApplicationDetailsData();
            this.saveApplicationDetailsData(applicationDetailsData);
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.setFormControls(application);
        }
    }
    getLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appController.selectedModuleID}) and ((name eq '${ViewApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${ViewApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${ViewApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}' and deleted eq false) or (name eq '${ViewApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}' and deleted eq false))`
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsEcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const applicantTypes = [];
        const phases = [];
        const conventionalPrepaid = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === `${ViewApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === `${ViewApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}`) {
                    applicantTypes.push(JSON.parse(item.content));
                }
                if (item.name === `${ViewApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}`) {
                    phases.push(JSON.parse(item.content));
                }
                if (item.name === `${ViewApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}`) {
                    conventionalPrepaid.push(JSON.parse(item.content));
                }
            });
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsEcConstants.APPLICATION_TYPE_LOOKUP_NAME}`, applicationTypes);
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsEcConstants.APPLICANT_TYPE_LOOKUP_NAME}`, applicantTypes);
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsEcConstants.PHASE_LOOKUP_NAME}`, phases);
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsEcConstants.CONVENTIONAL_PREPAID_LOOKUP_NAME}`, conventionalPrepaid);
            this.applicationTypes = applicationTypes;
            this.applicantTypes = applicantTypes;
            this.phases = phases;
            this.conventionalPrepaidOptions = conventionalPrepaid;
            this.changeDetectorRefs.detectChanges();
            this.getApplication();
        }
    }
    setFormControls(application) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
        this.detailsForm.get(this.applicationTypeFormControlName).setValue(application.applicationType);
        this.detailsForm.get(this.applicantTypeFormControlName).setValue(application.applicantType);
        this.detailsForm.get(this.descriptionOfProposedWorkFormControlName).setValue(application.descriptionOfProposedWork);
        this.detailsForm.get(this.phaseFormControlName).setValue(application.phase);
        this.detailsForm.get(this.paymentTypeControlName).setValue(application.paymentType);
        this.detailsForm.get(this.estimatedCapacityControlName).setValue(application.estimatedCapacity);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.referenceNumberControlName).disable();
        this.detailsForm.get(this.applicationTypeFormControlName).disable();
        this.detailsForm.get(this.applicantTypeFormControlName).disable();
        this.detailsForm.get(this.descriptionOfProposedWorkFormControlName).disable();
        this.detailsForm.get(this.phaseFormControlName).disable();
        this.detailsForm.get(this.paymentTypeControlName).disable();
        this.detailsForm.get(this.estimatedCapacityControlName).disable();
    }
    buildApplicationDetailsData() {
        const applicationData = {
            description: this.detailsForm.get(this.descriptionFormControlName).value,
            applicationType: this.detailsForm.get(this.applicationTypeFormControlName).value,
            applicantType: this.detailsForm.get(this.applicantTypeFormControlName).value,
            descriptionOfProposedWork: this.detailsForm.get(this.descriptionOfProposedWorkFormControlName).value,
            phase: this.detailsForm.get(this.phaseFormControlName).value,
            paymentType: this.detailsForm.get(this.paymentTypeControlName).value,
            estimatedCapacity: this.detailsForm.get(this.estimatedCapacityControlName).value,
            referenceNumber: this.detailsForm.get(this.referenceNumberControlName).value
        };
        return applicationData;
    }
    saveApplicationDetailsData(applicationDetailsData) {
        this.getApplicationSaveObservableSubscription =
            this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, applicationDetailsData)
                .subscribe({
                next: (savedApplication) => {
                    if (savedApplication) {
                        this.setFormControls(savedApplication);
                        this.appController.showMessage(`${SharedConstants.UPDATE_SUCCESS}`, AlertType.Success);
                    }
                }, error: (error) => {
                    this.appController.handleServerErrorMessage(ViewApplicationDetailsEcConstants.STEP_TITLE, error, CRUDOperation.Update);
                }
            });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsEcComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-ec",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsEcComponent);
export { ViewApplicationDetailsEcComponent };
